<modal-header title="{{label}}"></modal-header>
<ion-content [formGroup]="formGroup">
    <ion-grid *ngIf="!!subHeader">
        <ion-row>
            <ion-col class="ion-text-end">
                {{ subHeader }}
            </ion-col>
        </ion-row>
    </ion-grid>
    <ion-grid *ngIf="!!max">
        <ion-row *ngIf="!!splitMax">
            <ion-col>
                <ion-segment mode="ios"
                             formControlName="selectedSplit"
                             [scrollable]="true"
                             (ionChange)="calculateSplit()">
                    <ion-segment-button [value]="2">
                        <ion-label>2</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [value]="3">
                        <ion-label>3</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [value]="4">
                        <ion-label>4</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [value]="5">
                        <ion-label>5</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [value]="6">
                        <ion-label>6</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [value]="7">
                        <ion-label>7</ion-label>
                    </ion-segment-button>
                    <ion-segment-button [value]="8">
                        <ion-label>8</ion-label>
                    </ion-segment-button>
                </ion-segment>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size-xs="6" class="max-container">
                <ion-item>
                    <bb-labelled-item label="Max" value="{{max | currency}}"></bb-labelled-item>
                    <ion-icon class="arrow" name="arrow-forward-outline" slot="end" (click)="setToMax()"></ion-icon>
                </ion-item>
            </ion-col>

            <ion-col size-xs="6">
                <ion-item>
                    <ion-label class="floating-label" position="stacked">
                        {{label}}
                    </ion-label>
                    <ion-input formControlName="dollarAmount"
                               bbCurrencyMaskPrefix
                               inputmode="numeric"
                               class="tip-input-small"
                               #manualAmount>
                    </ion-input>
                </ion-item>
            </ion-col>
        </ion-row>
    </ion-grid>
    <ion-item *ngIf="!max">
        <ion-input formControlName="dollarAmount"
                   bbCurrencyMaskPrefix
                   inputmode="numeric"
                   class="tip-input"
                   #manualAmount>
        </ion-input>
    </ion-item>
</ion-content>
<modal-footer [disableSubmit]="formGroup.invalid" (submitClicked)="formatAndClose()" submitLabel="Confirm"></modal-footer>
